import {SignupSend} from "../../types/user/authData";
import {BaseResponse} from "../../types/baseEntities";
import {HttpAxiosRequest} from "../httpAxiosBase";

export const HttpOnboardingAuth = {
    getEndpoint: (url = ''): string => `onboarding-auth${url}`,

    register : (data: SignupSend) : Promise<BaseResponse> => {
        return HttpAxiosRequest.post(
            HttpOnboardingAuth.getEndpoint('/sign-up'),
            data
        )
    }
}